const SectionTitle = ({ SectionName, className }) => {
    return (
        <div className={className}>
            {/* Eyebrow label */}
            <div className="flex items-center gap-2 mb-2">
                <div
                    style={{
                        width: "18px",
                        height: "1px",
                        background: "rgba(200,151,42,0.6)",
                    }}
                />
                <span
                    style={{
                        fontSize: "9px",
                        letterSpacing: "0.28em",
                        textTransform: "uppercase",
                        color: "rgba(200,151,42,0.7)",
                        fontWeight: 500,
                    }}
                >
                    {SectionName}
                </span>
            </div>

            {/* Main title */}
            <h2
                className="font-bold text-white"
                style={{ fontSize: "26px", letterSpacing: "-0.02em", lineHeight: 1.1 }}
            >
                {SectionName}
            </h2>

            {/* Gold accent bar */}
            <div
                className="mt-2"
                style={{
                    width: "32px",
                    height: "2px",
                    borderRadius: "2px",
                    background:
                        "linear-gradient(90deg, #C8972A, rgba(200,151,42,0.3))",
                }}
            />
        </div>
    );
};

export default SectionTitle;
